import {
  APIAllInstallationsCDL,
  APIAllInstallationsMarket,
  APIAllInstallationsProduct,
  APIAllInstallationsUF,
  APIAllInstallationsVendor,
} from "../core/contracts/AllInstallationsFilter";
import { AllInstallationsFilterGet } from "../core/models/AllInstallationsFilter";
import VideoAfterSales from "../core/models/VideoAfterSales";
import { SessionCache } from "../helpers/cache";
import BaseService from "./BaseService";

export default class VideoAfterSalesService {
  async fetchAllVideosAfterSales() {
    try {
      // product filter
      const videos: VideoAfterSales[] = await new BaseService(true).get("/core/VideosAfterSales");
      return videos;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn(
        "🚀 ~ file: VideoAfterSalesService.ts ~ VideoAfterSalesService ~ fetch ~ error",
        error
      );
      return Promise.reject("Unable to resolve video promises!");
    }
  }
}
